// Single source of truth for score → plain-English phrase.
// Used identically on Sessions LIST and Session DETAIL so the two never disagree.
// Five buckets, locked 2026-04. Do NOT add more phrases.

export const scoreBucket = (score) => {
  if (score === null || score === undefined || Number.isNaN(Number(score))) {
    return { label: 'Not scored', tone: 'neutral' };
  }
  const v = Number(score);
  if (v >= 90) return { label: 'Excellent',     tone: 'excellent' };
  if (v >= 80) return { label: 'Good',          tone: 'good' };
  if (v >= 60) return { label: 'Average',       tone: 'average' };
  if (v >= 50) return { label: 'Below Average', tone: 'below' };
  return            { label: 'Poor',            tone: 'poor' };
};

// Tailwind color class per tone. Green → red gradient, one color per bucket.
export const toneClass = (tone) => {
  if (tone === 'excellent') return 'text-green-400';
  if (tone === 'good')      return 'text-lime-400';
  if (tone === 'average')   return 'text-yellow-400';
  if (tone === 'below')     return 'text-orange-400';
  if (tone === 'poor')      return 'text-red-400';
  return 'text-zinc-500';
};

// Hex color for inline styles (border-left, etc).
export const toneHex = (tone) => {
  if (tone === 'excellent') return '#4ADE80';
  if (tone === 'good')      return '#A3E635';
  if (tone === 'average')   return '#FACC15';
  if (tone === 'below')     return '#FB923C';
  if (tone === 'poor')      return '#F87171';
  return '#52525B';
};

// "2.1s" / "—"
export const formatTempo = (sec) => {
  const v = Number(sec) || 0;
  if (v <= 0) return '—';
  return `${v.toFixed(1)}s`;
};

// Tempo intent bucket — used by the LIVE camera overlay to label tempo in real time.
// Not a score; just classifies pace for the tiny on-screen chip.
export const tempoIntent = (tempoSec) => {
  const t = Number(tempoSec) || 0;
  if (t <= 0) return { key: 'unknown', label: 'Unknown' };
  if (t < 1.5) return { key: 'explosive', label: 'Explosive' };
  if (t < 2.5) return { key: 'normal', label: 'Normal' };
  if (t < 4.0) return { key: 'controlled', label: 'Controlled' };
  return { key: 'very_slow', label: 'Very slow' };
};


// Turn an axios upload/analysis error into a short, user-facing message — never
// the raw Cloudflare/origin HTML, with a clear hint when a large clip timed out.
export const friendlyUploadError = (err, fallback = 'Could not analyze that clip. Try a clearer one.') => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d.length > 0 && d.length < 200 && !d.includes('<')) return d;
  if (err?.code === 'ECONNABORTED') return 'That took too long to analyze — try a shorter clip (5-8 seconds).';
  const status = err?.response?.status;
  if ([502, 503, 504, 520, 521, 522, 524].includes(status)) {
    return 'The clip was too large to analyze in time — try a shorter 5-8 second clip.';
  }
  return fallback;
};
